import { render, staticRenderFns } from "./DreamWindow.vue?vue&type=template&id=17d71af2&scoped=true"
import script from "./DreamWindow.vue?vue&type=script&lang=js"
export * from "./DreamWindow.vue?vue&type=script&lang=js"
import style0 from "./DreamWindow.vue?vue&type=style&index=0&id=17d71af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d71af2",
  null
  
)

export default component.exports